import React, { useEffect, useRef, useState, useMemo } from 'react';

export const SearchBox = ({ people, onSelect }: { people: any; onSelect: (val: any) => void }) => {
  const [query, setQuery] = useState('');
  const suggestions = people.filter((p: any) => p.name.toLowerCase().includes(query.toLowerCase()));

  return (
    <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 1000 }}>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="חפש שם..."
        style={{ padding: '5px', width: '200px' }}
      />
      {query && (
        <ul style={{ background: 'white', border: '1px solid #ccc', listStyle: 'none', padding: 0, margin: 0, maxHeight: '150px', overflowY: 'auto' }}>
          {suggestions.map((p: any) => (
            <li
              key={p.id}
              onClick={() => {
                onSelect(p.id);
                setQuery('');
              }}
              style={{ padding: '5px', cursor: 'pointer' }}
            >
              {p.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};